/*
 * @Description: 推广相关问卷数据分析
 * @Date: 2024-01-11 14:07:18
 */
const views = (require as any).context(
  './',
  true,
  /pc-module-promotion-\d+\.vue/
);

export default views.keys().map(path => {
  return views(path).default;
});
